module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/mobile-bottom-img.a47fe0f2.png";